import domtoimage from 'dom-to-image';
import { jsPDF } from 'jspdf';

export const downloadPDF = async (printRef, pdfName, filterClass) => {
  const element = printRef;

  const scale = 1;
  const dataUrl = await domtoimage.toPng(element, {
    quality: 1, // massima qualità possibile
    style: {
      backgroundColor: 'white',
      transform: `scale(${scale})`,
      transformOrigin: 'top left',
    },
  });
  //console.log('dataUrl', dataUrl);
  var data = new Image();
  data.src = dataUrl;

  const pdf = new jsPDF('p', 'mm', 'a4', true);

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgProps = pdf.getImageProperties(dataUrl);
  const imgWidthPx = imgProps.width;
  const imgHeightPx = imgProps.height;

  const pdfImgWidth = pageWidth * 0.95;
  const ratio = imgHeightPx / imgWidthPx;
  const pdfImgHeight = pdfImgWidth * ratio;

  let finalWidth = pdfImgWidth;
  let finalHeight = pdfImgHeight;

  if (pdfImgHeight > pageHeight * 0.95) {
    finalHeight = pageHeight * 0.95;
    finalWidth = finalHeight / ratio;
  }

  const marginX = (pageWidth - finalWidth) / 2;
  const marginY = 10;

  pdf.addImage(dataUrl, 'PNG', marginX, marginY, finalWidth, finalHeight);
  pdf.save(`${pdfName}.pdf`);
};
export default downloadPDF;
